import React, { useEffect } from "react";
import DashBoardNavbar from "../Comps/DashBoard/DashBoardNavbar";
import ReportsNavbar from "../Comps/Reports/ReportsNavbar";
import ReportsBody from "../Comps/Reports/ReportsBody";
const DashBoard = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="newUi text-center m-1 " style={{ minHeight: "90vh" }}>
      <DashBoardNavbar />
      <ReportsNavbar />
      <ReportsBody />
    </div>
  );
};
export default DashBoard;
